import { useCallback } from "react";
import { Pressable } from "react-native";

import { Attention, useChatBlock, useChatUnblock } from "../services";
import { Col, Spinner, TextLabel } from "../lib";

type Props = {
  id: number;
  blocked?: boolean;
  userName: string;
};

export function ChatActionBar({ id, blocked = false, userName }: Props) {
  // Vars
  const [blockChat, isBlocking] = useChatBlock({ chatId: id });
  const [unblockChat, isUnblocking] = useChatUnblock({ chatId: id });

  // Handlers
  const toggleBlock = useCallback(async () => {
    if (blocked) {
      await unblockChat();
    } else if (
      await Attention.confirm(
        "Block client",
        `Are you sure you want to block ${userName}?`
      )
    ) {
      await blockChat();
    }
  }, [blockChat, blocked, unblockChat, userName]);

  // Render
  return (
    <Col pr="4">
      <Pressable onPress={toggleBlock}>
        {isBlocking || isUnblocking ? (
          <Spinner />
        ) : (
          <TextLabel em color="onSurface">
            {blocked ? "UNBLOCK" : "BLOCK"}
          </TextLabel>
        )}
      </Pressable>
    </Col>
  );
}
